import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { Prop } from "vue-property-decorator";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "TrainingRegistrationAdd" })
export default class TrainingRegistrationAdd extends Vue {
    public localizer: any = Localizer;
    public courseData: any = null;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isUnsubscribe: boolean = false;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly trainingCourseIdMaster: string;
    @Prop() readonly returnUrl: string;
    @Prop() readonly trainingCourseTitle: string;

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.courseData = (await Axios.post(this.routes.MyMectronicTraining_GetTrainingRegistrationData, { trainingCourseIdMaster: this.trainingCourseIdMaster }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    }

    public formatToLocalDate(date: Date): string {
        let newData = new Date(date);
        var day = String(newData.getDate()).padStart(2, '0');
        var month = String(newData.getMonth() + 1).padStart(2, '0'); //January is 0!
        var year = newData.getFullYear();
        var hour = String(newData.getUTCHours()).padStart(2, '0');
        var minute = String(newData.getUTCMinutes()).padStart(2, '0');

        return day + '/' + month + '/' + year + ', ' + hour + ':' + minute;
    }

    public async submitRegistration() {
        this.isLoading = true;

        try {
            this.isSuccess = false;

            await Axios.post(this.routes.MyMectronicTraining_SetTrainingRegistrationData, { trainingCourseIdMaster: this.trainingCourseIdMaster }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

            this.isSuccess = true;

            GTagHelper.sendEvent("form_submit", "course_subscribe");

            window.location.href = window.location.href;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async submitUnsubscribe() {
        this.isLoading = true;

        try {
            this.isSuccess = false;

            await Axios.post(this.routes.MyMectronicTraining_UpdateTrainingRegistrationData, { trainingCourseIdMaster: this.trainingCourseIdMaster }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

            this.isSuccess = true;
            
            GTagHelper.sendEvent("form_submit", "course_unsubscribe");

            window.location.href = window.location.href;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
        if (this.isSuccess) {
            this.isUnsubscribe = true;
        }
    }

    public openAccountEdit() {
        let redirectUrl = this.routes.AccountProfile_Edit;
        if (this.returnUrl) {
            redirectUrl += "?returnurl=" + this.returnUrl;
        }

        window.location.href = redirectUrl;
    }
};